import { createActions, createReducer } from 'reduxsauce'

import { AuthenticationTypes } from '../authentication/duckAuthentication'

/* Initial State */
const INITIAL_STATE = {
  defaultLanguage: 'en',
  selected: window.navigator.language?.split('-')[0]
}

/**
 * Creating actions and types with reduxsauce.
 */
const { Types, Creators } = createActions({
  changeLanguage: ['language']
})

const changeLanguage = (state = INITIAL_STATE, { language }) => ({
  ...state,
  selected: language
})

const logout = () => ({ ...INITIAL_STATE })

/**
 * Creating reducer with Types.
 */
export default createReducer(INITIAL_STATE, {
  [Types.CHANGE_LANGUAGE]: changeLanguage,

  [AuthenticationTypes.LOGOUT]: logout
})

export {
  Types as LanguageTypes,
  Creators as LanguageActions
}
